module.exports = __webpack_public_path__ + "img/list1.b406d193.png";